import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {Object} from 'es6-shim';
import {diff} from 'deep-object-diff';
import {IClassiDocumentali, IPreviousYears, IUser} from '../../../../commons/interfaces/user/user';

interface IUserT {
  email: string;
  piva: string;
  codice_fiscale: string;
  company_name: string;
  _id: string;
  classiDocumentali: IClassiDocumentali;
  previousYears: IPreviousYears;
}

type IYearList = { anno: number, scadenza?: Date }[];

class GestioneAnniPrecedentiContoller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService'
  ];

  constructor(
    private $scope: {
      originalUsers: IUser[],
      usersList: IUserT[],
      filtroScadenza: string[],
      user: IUserT,
      enableRiepilogo: boolean,
      classiList: { name: string, value: string }[],
      riepilogoUser: {
        classe: string;
        anniPrecedenti: {
          anno: number;
          scadenza: string;
          scaduto: boolean;
        }[];
      }[],
      classe: { value: { name: string, value: string } },
      yearsList: IYearList,
      anniPrecedenti: IYearList,
      getUsersTypeaheadValues: () => void,

      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
  ) {
    $scope.pageHeader = 'Gestione Anni Precedenti';
    $scope.pageSubHeader = 'Scegli l\'utente per la gestione degli anni precedenti';
    $scope.user = undefined;
    $scope.riepilogoUser = [];
    $scope.classe = {value: undefined};
    $scope.anniPrecedenti = [];
    $scope.filtroScadenza = [];
    $rootScope.formsubmitted = false;
    $scope.classiList = [];
    $scope.usersList = [];
    $scope.yearsList = [2, 3, 4, 5, 6, 7, 8, 9, 10].map(anno => {
      return {anno: (new Date()).getFullYear() - anno, scadenza: null};
    });

    let anagrafica = [] as IUserT[];

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.filterScaduti = () => {
      $scope.usersList = anagrafica.filter(item => {
        const ragSociale = item.company_name.toLowerCase().includes($scope.filtroScadenza[0] && $scope.filtroScadenza[0].toLowerCase() || '');
        const piva = item.piva.toLowerCase().includes($scope.filtroScadenza[1] && $scope.filtroScadenza[1].toLowerCase() || '');
        const codice_fiscale = item.codice_fiscale.toLowerCase().includes($scope.filtroScadenza[8] && $scope.filtroScadenza[8].toLowerCase() || '');
        const email = item.email.toLowerCase().includes($scope.filtroScadenza[2] && $scope.filtroScadenza[2].toLowerCase() || '');
        return ragSociale && piva && codice_fiscale && email;
      });
    };

    $scope.setClassiDocumentali = (id) => {

      $scope.user = anagrafica.find(item => item._id === id);

      $scope.enableRiepilogo = false;
      ArchiSmallServices.getClassiDocumentali().then(response => {
        const classi = JSON.parse(JSON.stringify(response)) as IClassiDocumentali;
        $scope.classiList = Object.keys(classi).filter(classe => {
          // filtra solo classi abilitate
          return $scope.user.classiDocumentali[classe];
        }).map(classe => {
          // mappa nomi
          return {name: classe.toUpperCase().split('_').join(' '), value: classe};
        }).sort(({name: a}, {name: b}) => a.localeCompare(b));

        $scope.riepilogoUser = $scope.user.previousYears ? Object.keys($scope.user.previousYears).map(item => {
          const className = item.toUpperCase().split('_').join(' ');
          return {
            classe: className,
            anniPrecedenti: $scope.user.previousYears[item].map(annoPrecedente => {
              if (annoPrecedente.scadenza) {
                $scope.enableRiepilogo = true;
              }
              return {
                anno: annoPrecedente.anno,
                scadenza: new Date(annoPrecedente.scadenza).toLocaleDateString(),
                scaduto: annoPrecedente.scadenza < Date.now()
              };
            })
          };
        }).sort(({classe: a}, {classe: b}) => a.localeCompare(b)) : undefined;
        // reinizializza queste per evitare problemi dopo
        $scope.resetVariables();
      });
    };

    $scope.resetVariables = () => {
      $scope.classe = {value: undefined};
      $scope.anniPrecedenti = [];
      $scope.yearsList = [2, 3, 4, 5, 6, 7, 8, 9, 10].map(anno => {
        return {anno: (new Date()).getFullYear() - anno, scadenza: null};
      });
    };

    $scope.setAnniPrecedenti = () => {
      $scope.anniPrecedenti = (JSON.parse(JSON.stringify($scope.yearsList)) as IYearList).map(item => {
        if (
          $scope.user.previousYears &&
          $scope.user.previousYears[$scope.classe.value.value] &&
          $scope.user.previousYears[$scope.classe.value.value].find(prevY => prevY.anno === item.anno)
        ) {
          const temp = $scope.user.previousYears[$scope.classe.value.value].find(prevY => prevY.anno === item.anno);
          // console.log(item);
          item.scadenza = new Date(temp.scadenza);
          // console.log(item);

        }
        return item;
      });
    };

    $scope.getUsersTypeaheadValues = () => {
      ArchiSmallServices.getUsers()
        .then((response) => {
          ArchiSmallServices.getClassiDocumentali().then(resclassi => {
            const classidefault = JSON.parse(JSON.stringify(resclassi)) as IClassiDocumentali;

            $scope.originalUsers = JSON.parse(JSON.stringify(response)) as IUser[];

            anagrafica = (JSON.parse(JSON.stringify(response)) as IUser[]).reverse().map(item => {
              return {
                email: item.accountData.email,
                piva: item.organizationData.PIVA,
                codice_fiscale: item.organizationData.fiscalCode,
                company_name: item.organizationData.name ||
                  (item.organizationData.contactPerson.firstname + ' ' + item.organizationData.contactPerson.surname),
                _id: item._id,
                classiDocumentali: {...classidefault, ...item.classiDocumentali},
                previousYears: item.previousYears
              };
            }).sort(({company_name: a}, {company_name: b}) => a.localeCompare(b));

            // console.log(response);
          }, (error) => {
            $rootScope.alert('error', error);
          });
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };
    $scope.getUsersTypeaheadValues();

    $scope.openConfermaModal = (size) => {
      // console.log('originale', $scope.user);

      // in javascript se usi l'assegnazione normale hai di fatto 2 variabili che puntano alla stessa nella memoria
      // vedi Shallow Copy vs Deep Copy
      // https://www.javascripttutorial.net/object/3-ways-to-copy-objects-in-javascript/
      const userUpdated = JSON.parse(JSON.stringify($scope.originalUsers.find(user => {
        return user._id === $scope.user._id;
      }))) as IUser;

      const userOriginal = JSON.parse(JSON.stringify($scope.originalUsers.find(user => {
        return user._id === $scope.user._id;
      }))) as IUser;

      // filtra solo per gli anni con una scadenza (esclude i null dal database)
      userUpdated.previousYears[$scope.classe.value.value] = $scope.anniPrecedenti.filter(item => item.scadenza !== null).map(item => ({
        ...item,
        scadenza: item.scadenza.getTime()
      }));
      // console.log($scope.user.previousYears[$scope.classe.value.value].filter(item => item.scadenza !== null));

      userUpdated.last_differences = JSON.stringify({previousYears: diff(userOriginal.previousYears, userUpdated.previousYears)});

      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'confermaComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return userUpdated;
          },
          otherUpdate: true,
          diffs: () => {
            return userUpdated.last_differences;
          }
        }
      });

      setTimeout($scope.getUsersTypeaheadValues, 3000);

      $scope.user = undefined;
      $scope.riepilogoUser = [];
      $scope.filtroScadenza = [];
      $scope.usersList = [];
      $scope.resetVariables();
    };
    // </editor-fold>
    // $scope.updateUser = () => {
    //   this.ArchiSmallServices.updateOtherUser()
    // }

  }
}

export const GestioneAnniPrecedentiComponent: ng.IComponentOptions = {
  template: require('./gestione-anni-precedenti.html'),
  controller: GestioneAnniPrecedentiContoller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-anni-precedenti/gestione-anni-precedenti.ts